import { BaseFilter } from './cim-substation.model';

export class EditAcLineSegment {
  id: number | null = null;
  number: string = '';
  name: string = '';
  // voltage: Voltage;
  acLineType!: AcLineType;
  parentSubstationId: number = 0;
  powerTransformerId: number = 0;
  parentAcLineId?: number;
  boundaryId?: number;
  feederBand?: FeederBand;
  customerTariffScope?: CustomerTariffScope;
  meterNumber: string = '';
  meterBrandId?: number;
  latitude?: number;
  longitude?: number;
  // baseVoltageId: number = 0;
  // regionId: number = 0;
}

export enum AcLineSegmentType {
  Main = 0,
  Primary = 1,
  Secondary = 2,
  Incomer = 3,
  Boundary = 4
}

export enum AcLineType {
  Incoming = 0,
  Outgoing = 1,
}
export class AcLineSegmentDto {
  id?: number | null;
  boundaryId?: number;
  name: string;
  number!: string;
  electricalAddress: string;
  substationType: string;
  substationName: string;
  region: string;
  feederBand: string;
  baseVoltage: string;

  constructor(data?: any) {
    this.id = data?.id ?? null;
    this.name = data?.name ?? '';
    this.electricalAddress = data?.electricalAddress ?? '';
    this.substationType = data?.substationType ?? '';
    this.substationName = data?.substationName ?? '';
    this.region = data?.region ?? '';
    this.baseVoltage = data?.baseVoltage ?? '';
    this.feederBand = data?.feederBand ?? '';
  }
}

export class AcLineSegmentFilter extends BaseFilter {
  searchType: AcLineSearchType = AcLineSearchType.Name;
  substationTemplateIds: number[] = [];
  acLineType: AcLineSegmentType = AcLineSegmentType.Main;
  module: string = '';
}

export enum AcLineSearchType {
  Name = 1,
  Number = 2,
  SubstationName = 3,
}

export class SelectAcLineDto {
    id?: number;
    name: string;
    baseVoltage: string;

    constructor(data?: any){
        this.id = data?.id ?? null;
        this.name = data?.name ?? ''; 
        this.baseVoltage = data?.baseVoltage ?? ''; 
    }
}

export interface AcLineForSubstationAdvancedMapDto {
  id: number;
  name: string;
}

export interface AcLinesForSubstationAdvancedMapDataOut {
  incomingAcLines: AcLineForSubstationAdvancedMapDto[];
  outgoingAcLines: AcLineForSubstationAdvancedMapDto[];
}

export class SearchAcLineSegmentDto {
  acLineType!: number;
  searchTerm!: string;
}

export class AcLineSelectForMapDataOut {
  id!: number;
  name!: string;
}

export enum FeederBand {
  BandA = 1,
  BandB = 2,
  BandC = 3,
  BandD = 4,
  BandE = 5
}

export interface AcLineHistoryDataOut {
  timestamp: Date;
  user: string;
  userRole: string;
  userEmail: string;
  previousName: string | null;
  newName: string | null;
  previousNumber: string | null;
  newNumber: string | null;
  previousBand: string | null;
  newBand: string | null;
  previousCustomerType: string | null;
  newCustomerType: string | null;
  previousParentSubstation: string | null;
  newParentSubstation: string | null;
}

export class SelectFeederBandDto {
    id?: number;
    name: string;

    constructor(data?: any){
        this.id = data?.id ?? null;
        this.name = data?.name ?? '';
    }
}

export enum CustomerTariffScope {
  Prepaid = 1,
  Postpaid = 2,
  Both = 3
}

export class SelectCustomerTariffDto {
    id?: number;
    name: string;

    constructor(data?: any){
        this.id = data?.id ?? null;
        this.name = data?.name ?? '';
    }
}